import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { InputField, Select } from '@enamelai/design-system'
import { Patient } from '@dataTypes/PatientInfo.types'
import { USStates } from '@constants/Common/personalInfo.constants'
import { APIProvider } from '@vis.gl/react-google-maps'
import AddressField from '@components/common/AddressField/AddressField.component'
import { getEnv } from '@utils/env'

const GOOGLE_MAPS_API_KEY = getEnv('REACT_APP_GOOGLE_MAPS_API_KEY', '')

type AddressFieldsProps = {
  patientData: Patient
  handleInputChange: (field: keyof Patient, value: string) => void
  validationErrors: { [key: string]: string }
}

const AddressFields: React.FC<AddressFieldsProps> = ({
  patientData,
  handleInputChange,
  validationErrors,
}) => {
  return (
    <>
      <Row className="g-2">
        <Col md={12} className="add-patient-address">
          <APIProvider apiKey={GOOGLE_MAPS_API_KEY} libraries={['places']}>
            <AddressField
              ds
              label="Address"
              placeholder="Enter an address"
              value={patientData.address}
              onChange={(e) => handleInputChange('address', e)}
              countries={['US']}
              onSelect={(place, parsed) => {
                handleInputChange('address', parsed.formattedAddress2 ?? '')
                handleInputChange('city', parsed.city ?? '')
                handleInputChange('state', parsed.state ?? '')
                handleInputChange('zip', parsed.postalCode ?? '')
              }}
              hint={validationErrors.address || undefined}
              destructive={!!validationErrors.address}
            />
          </APIProvider>
        </Col>
      </Row>
      <Row className="g-2">
        <Col md={6}>
          <InputField
            fullWidth
            variant="text"
            label="City/town"
            placeholder="Enter a city"
            value={patientData.city || ''}
            onChange={(e) => handleInputChange('city', e.target.value)}
            error={!!validationErrors.city}
            helperText={validationErrors.city || undefined}
          />
        </Col>
        <Col md={4}>
          <Select
            label="State"
            placeholder="--"
            options={USStates}
            value={patientData.state || ''}
            onChange={(value) => handleInputChange('state', String(value))}
            error={!!validationErrors.state}
            helperText={validationErrors.state || undefined}
          />
        </Col>
        <Col md={2}>
          <InputField
            fullWidth
            variant="text"
            label="Zip"
            placeholder="Zip"
            value={patientData.zip || ''}
            onChange={(e) => handleInputChange('zip', e.target.value)}
            error={!!validationErrors.zip}
            helperText={validationErrors.zip || undefined}
          />
        </Col>
      </Row>
    </>
  )
}

export default AddressFields
